// extracted by mini-css-extract-plugin
export default {"facetedTag":"TPf23HYgnkwdJCng6PQs"};